import { render, staticRenderFns } from "./CustomerListView.vue?vue&type=template&id=86c17230"
import script from "./CustomerListView.vue?vue&type=script&lang=js"
export * from "./CustomerListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86c17230')) {
      api.createRecord('86c17230', component.options)
    } else {
      api.reload('86c17230', component.options)
    }
    module.hot.accept("./CustomerListView.vue?vue&type=template&id=86c17230", function () {
      api.rerender('86c17230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/CustomerListView.vue"
export default component.exports